import request from './request'

export function getEsignTemplatePage(params) {
  return request.get('/esign/templates', { params })
}

export function getEsignTemplateDetail(id) {
  return request.get(`/esign/templates/${id}`)
}

export function createEsignTemplate(data) {
  return request.post('/esign/templates', data)
}

export function enableEsignTemplate(id) {
  return request.put(`/esign/templates/${id}/enable`)
}

export function disableEsignTemplate(id) {
  return request.put(`/esign/templates/${id}/disable`)
}

export function saveEsignTemplateParties(id, data) {
  return request.post(`/esign/templates/${id}/parties`, data)
}

export function saveEsignTemplateFields(id, data) {
  return request.post(`/esign/templates/${id}/fields`, data)
}

export function getEsignFlowPage(params) {
  return request.get('/esign/flows', { params })
}

export function getEsignFlowDetail(id) {
  return request.get(`/esign/flows/${id}`)
}

export function createEsignFlow(data) {
  return request.post('/esign/flows', data)
}

export function syncEsignFlow(id) {
  return request.post(`/esign/flows/${id}/sync`)
}

export function syncEsignFlowComponents(id) {
  return request.post(`/esign/flows/${id}/components/sync`)
}

export function modifyEsignFlowDeadline(id, data) {
  return request.put(`/esign/flows/${id}/deadline`, data)
}

export function remindEsignFlow(id, data) {
  return request.post(`/esign/flows/${id}/remind`, data)
}

export function releaseEsignFlow(id, data) {
  return request.post(`/esign/flows/${id}/release`, data)
}

export function supplementEsignApprovers(id, data) {
  return request.post(`/esign/flows/${id}/approvers`, data)
}

export function forwardEsignFlow(id, data) {
  return request.post(`/esign/flows/${id}/forward`, data)
}

export function cancelEsignFlow(id, data) {
  return request.post(`/esign/flows/${id}/cancel`, data)
}

export function archiveEsignFlow(id) {
  return request.post(`/esign/flows/${id}/archive`)
}

export function getEsignFlowFiles(id) {
  return request.get(`/esign/flows/${id}/files`)
}

export function getTencentEsignTemplates(params) {
  return request.get('/esign/tencent/templates', { params })
}

export function getTencentEsignSeals(params) {
  return request.get('/esign/tencent/seals', { params })
}

export function queryTencentUserVerifyStatus(params) {
  return request.get('/esign/tencent/user-verify-status', { params })
}

export function modifyTencentCallback(data) {
  return request.put('/esign/tencent/callback', data)
}

export function getEsignCallbackLogPage(params) {
  return request.get('/esign/callback-logs', { params })
}

export function retryEsignCallbackLog(id) {
  return request.post(`/esign/callback-logs/${id}/retry`)
}
